import { useUpcomingOutreach } from '../../../engage/campaigns/queries'
import ScrollingList from '../../ui/scrolling-list'
import { OutreachCard } from './outreach-card'
import { OutreachListSkeleton } from './outreach-list-skeleton'
import { OutreachSection } from './outreach-section'

function UpcomingOutreach() {
  const upcomingOutreach = useUpcomingOutreach()

  if (upcomingOutreach.data) {
    const outreachList = upcomingOutreach.data?.pages.flatMap((d) => d.data)

    return outreachList?.length ? (
      <OutreachSection title="Upcoming Outreach">
        <ScrollingList>
          {outreachList.map((outreach) => {
            // required since we don't discriminate campaign return
            if (outreach.className === 'Broadcast') return null

            return (
              <div key={outreach.objectId} className="flex w-36">
                <OutreachCard
                  key={outreach.objectId}
                  clientCount={outreach.stats.clientCount}
                  name={outreach.name}
                  startDate={outreach.startDate?.iso}
                />
              </div>
            )
          })}
        </ScrollingList>
      </OutreachSection>
    ) : null
  }

  return <OutreachListSkeleton />
}

export { UpcomingOutreach }
